<div class="dashboard-page">
  <!-- ============================================================
       BIENVENIDA
       ============================================================ -->
  <section class="dashboard-welcome">
    <div class="welcome-content">
      <span class="welcome-kicker">Panel principal</span>

      <h1 class="welcome-title">¡Bienvenido/a {{ user_name }}!</h1>

      <p class="welcome-subtitle">
        Gestiona tus firmas, plantillas y documentos desde un solo lugar.
      </p>
    </div>

    <button
      type="button"
      class="dashboard-help"
      (click)="onHelp(true)"
      aria-label="Ayuda"
      title="Ayuda"
    >
      <i class="fa fa-info"></i>
      <span>Ayuda</span>
    </button>
  </section>

  <!-- ============================================================
       ACCESOS RÁPIDOS
       Desktop: arriba
       Mobile: abajo
       ============================================================ -->
  <section class="quick-section">
    <div class="section-heading">
      <span class="section-kicker">Accesos rápidos</span>
      <h2>¿Qué deseas hacer?</h2>
    </div>

    <div class="quick-actions">
      <!-- FIRMAR -->
      <button
        type="button"
        data-tour="card-firmar"
        class="quick-action quick-action-primary"
        (click)="rederic('firmas/admin-simple')"
      >
        <span class="quick-icon quick-icon-blue">
          <i class="fa-solid fa-file-signature"></i>
        </span>

        <span class="quick-info">
          <strong>Firmar</strong>
          <small>Firma y administra tus documentos.</small>
        </span>

        <span class="quick-arrow">
          <i class="fa-solid fa-chevron-right"></i>
        </span>
      </button>

      <!-- PLANTILLAS -->
      <button
        type="button"
        data-tour="card-plantillas"
        class="quick-action"
        (click)="rederic('plantilla')"
      >
        <span class="quick-icon quick-icon-purple">
          <i class="fa-solid fa-file-lines"></i>
        </span>

        <span class="quick-info">
          <strong>Plantillas</strong>
          <small>Administra tus plantillas de firma.</small>
        </span>

        <span class="quick-arrow">
          <i class="fa-solid fa-chevron-right"></i>
        </span>
      </button>

      <!-- PERFIL -->
      <button
        type="button"
        data-tour="card-perfil"
        class="quick-action"
        (click)="rederic('perfil')"
      >
        <span class="quick-icon quick-icon-green">
          <i class="fa-solid fa-user"></i>
        </span>

        <span class="quick-info">
          <strong>Mi perfil</strong>
          <small>Consulta y administra tu información.</small>
        </span>

        <span class="quick-arrow">
          <i class="fa-solid fa-chevron-right"></i>
        </span>
      </button>
    </div>
  </section>

  <!-- ============================================================
       ACTIVIDAD
       ============================================================ -->
  <section class="activity-section">
    <div class="section-heading activity-heading">
      <span class="section-kicker">Actividad</span>

      <h2>Resumen de documentos</h2>

      <p>Consulta rápidamente el estado de tus procesos.</p>
    </div>

    <!-- SOLO MÓVIL -->
    <div class="mobile-swipe-hint">
      <i class="fa-solid fa-chevron-left"></i>

      <span>Desliza para cambiar de panel</span>

      <i class="fa-solid fa-chevron-right"></i>
    </div>

    <!-- ==========================================================
         GRID DESKTOP / CONTENEDOR GENERAL
         ========================================================== -->
    <div class="dashboard-panels">
      <!-- ========================================================
           LOS 3 PANELES QUE FORMAN EL CARRUSEL EN MÓVIL
           ======================================================== -->
      <div class="dashboard-carousel">
        <!-- ======================================================
             1. DOCUMENTOS POR FIRMAR
             ====================================================== -->
        <article data-tour="docs-pendientes" class="dashboard-panel">
          <!-- HEADER DESKTOP -->
          <button
            type="button"
            class="panel-header panel-header-desktop"
            (click)="isActiveCollapsed = !isActiveCollapsed"
            [attr.aria-expanded]="!isActiveCollapsed"
          >
            <div class="panel-header-left">
              <!-- <span class="panel-main-icon icon-blue">
                <i class="fa-solid fa-file-signature"></i>
              </span> -->

              <span class="panel-heading-text">
                <strong>Documentos por firmar</strong>
                <small>Pendientes de tu firma</small>
              </span>
            </div>

            <div class="panel-header-right">
              <span class="panel-counter">
                {{ totalItemsLotesPorFirmar }}
              </span>

              <span class="panel-collapse-icon">
                <i
                  class="fa-solid fa-chevron-down"
                  [class.rotate-180]="!isActiveCollapsed"
                >
                </i>
              </span>
            </div>
          </button>

          <!-- HEADER MÓVIL - ESTÁTICO -->
          <div class="panel-header panel-header-mobile">
            <div class="panel-header-left">
              <!-- <span class="panel-main-icon icon-blue">
                <i class="fa-solid fa-file-signature"></i>
              </span> -->

              <span class="panel-heading-text">
                <strong>Documentos por firmar</strong>
                <small>Pendientes de tu firma</small>
              </span>
            </div>

            <span class="panel-counter">
              {{ totalItemsLotesPorFirmar }}
            </span>
          </div>

          <!-- DESKTOP -->
          <div class="panel-desktop-content" [ngbCollapse]="isActiveCollapsed">
            <div class="panel-body">
              <ul class="panel-list">
                <li
                  *ngFor="let lote of lotesPorFirmar; index as i"
                  class="panel-list-item"
                  (click)="rederic('firmas/' + lote?.loteCertificado?.lote?.id)"
                  appLongPress
                  (longPress)="
                    onDocumentoLongPress(lote?.loteCertificado?.lote)
                  "
                >
                  <span
                    class="item-icon icon-blue"
                    [style]="
                      firmaUtils.getStyleFirma(
                        lote?.loteCertificado?.lote.firma_simple,
                        lote?.loteCertificado?.lote.id_servicio_externo,
                        lote?.loteCertificado?.lote.es_grupo,
                        lote?.loteCertificado?.lote.firma_por_plantilla
                      )
                    "
                  >
                    <i
                      class="{{
                        firmaUtils.getIconFirma(
                          lote?.loteCertificado?.lote.firma_simple,
                          lote?.loteCertificado?.lote.id_servicio_externo,
                          lote?.loteCertificado?.lote.es_grupo,
                          lote?.loteCertificado?.lote.firma_por_plantilla
                        )
                      }}"
                    ></i>
                  </span>

                  <span class="item-content">
                    <strong>
                      {{ lote?.loteCertificado?.lote?.titulo }}
                    </strong>
                    <small class="generado"> Generado por: {{lote?.loteCertificado?.lote?.usuario?.firstName}}  {{lote?.loteCertificado?.lote?.usuario?.lastName}}</small>

                    <small>
                      {{
                        formatFechaLocalSinUTC(
                          lote?.loteCertificado?.lote?.createdAt
                        )
                      }}
                      -
                      {{
                        firmaUtils.getTipoFirma(
                          lote?.loteCertificado?.lote.firma_simple,
                          lote?.loteCertificado?.lote.id_servicio_externo,
                          lote?.loteCertificado?.lote.es_grupo,
                          lote?.loteCertificado?.lote.firma_por_plantilla
                        )
                      }}
                    </small>
                  </span>

                  <span class="item-arrow">
                    <i class="fa-solid fa-chevron-right"></i>
                  </span>
                </li>
              </ul>
            </div>

            <div
              class="panel-footer"
              *ngIf="
                !isActiveCollapsed &&
                totalItemsLotesPorFirmar > lotesPorFirmar.length
              "
            >
              <span>
                Mostrando {{ lotesPorFirmar.length }} de
                {{ totalItemsLotesPorFirmar }}
              </span>

              <button
                type="button"
                class="panel-more"
                (click)="rederic('documentos-por-firmar/documentos-por-firmar')"
              >
                Ver todos
                <i class="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>

          <!-- MÓVIL SIEMPRE ABIERTO -->
          <div class="panel-mobile-content">
            <div class="panel-body">
              <ul class="panel-list">
                <li
                  *ngFor="let lote of lotesPorFirmar; index as i"
                  class="panel-list-item"
                  (click)="rederic('firmas/' + lote?.loteCertificado?.lote?.id)"
                  appLongPress
                  (longPress)="
                    onDocumentoLongPress(lote?.loteCertificado?.lote)
                  "
                >
                  <span
                    class="item-icon icon-blue"
                    [style]="
                      firmaUtils.getStyleFirma(
                        lote?.loteCertificado?.lote.firma_simple,
                        lote?.loteCertificado?.lote.id_servicio_externo,
                        lote?.loteCertificado?.lote.es_grupo,
                        lote?.loteCertificado?.lote.firma_por_plantilla
                      )
                    "
                  >
                    <i
                      class="{{
                        firmaUtils.getIconFirma(
                          lote?.loteCertificado?.lote.firma_simple,
                          lote?.loteCertificado?.lote.id_servicio_externo,
                          lote?.loteCertificado?.lote.es_grupo,
                          lote?.loteCertificado?.lote.firma_por_plantilla
                        )
                      }}"
                    ></i>
                  </span>

                  <span class="item-content">
                    <strong>
                      {{ lote?.loteCertificado?.lote?.titulo }}
                    </strong>
                    <small class="generado"> Generado por: {{lote?.loteCertificado?.lote?.usuario?.firstName}}  {{lote?.loteCertificado?.lote?.usuario?.lastName}}</small>
                    <small>
                      {{
                        formatFechaLocalSinUTC(
                          lote?.loteCertificado?.lote?.createdAt
                        )
                      }}
                      -
                      {{
                        firmaUtils.getTipoFirma(
                          lote?.loteCertificado?.lote.firma_simple,
                          lote?.loteCertificado?.lote.id_servicio_externo,
                          lote?.loteCertificado?.lote.es_grupo,
                          lote?.loteCertificado?.lote.firma_por_plantilla
                        )
                      }}
                    </small>
                  </span>

                  <span class="item-arrow">
                    <i class="fa-solid fa-chevron-right"></i>
                  </span>
                </li>
              </ul>
            </div>

            <div
              class="panel-footer"
              *ngIf="totalItemsLotesPorFirmar > lotesPorFirmar.length"
            >
              <span>
                Mostrando {{ lotesPorFirmar.length }} de
                {{ totalItemsLotesPorFirmar }}
              </span>

              <button
                type="button"
                class="panel-more"
                (click)="rederic('documentos-por-firmar/documentos-por-firmar')"
              >
                Ver todos
                <i class="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </article>

        <!-- ======================================================
             2. FIRMAS PENDIENTES / AVANCE
             ====================================================== -->
        <article data-tour="avance-firmas" class="dashboard-panel">
          <!-- HEADER DESKTOP -->
          <button
            type="button"
            class="panel-header panel-header-desktop"
            (click)="isGroupCollapsed = !isGroupCollapsed"
            [attr.aria-expanded]="!isGroupCollapsed"
          >
            <div class="panel-header-left">
              <!-- <span class="panel-main-icon icon-purple">
                <i class="fa-solid fa-chart-line"></i>
              </span> -->

              <span class="panel-heading-text">
                <strong>Firmas pendientes / avance</strong>
                <small>Seguimiento de tus lotes</small>
              </span>
            </div>

            <div class="panel-header-right">
              <span class="panel-counter">
                {{ totalItemsLotesGestionar }}
              </span>

              <span class="panel-collapse-icon">
                <i
                  class="fa-solid fa-chevron-down"
                  [class.rotate-180]="!isGroupCollapsed"
                >
                </i>
              </span>
            </div>
          </button>

          <!-- HEADER MÓVIL -->
          <div class="panel-header panel-header-mobile">
            <div class="panel-header-left">
              <!-- <span class="panel-main-icon icon-purple">
                <i class="fa-solid fa-chart-line"></i>
              </span> -->

              <span class="panel-heading-text">
                <strong>Firmas pendientes / avance</strong>
                <small>Seguimiento de tus lotes</small>
              </span>
            </div>

            <span class="panel-counter">
              {{ totalItemsLotesGestionar }}
            </span>
          </div>

          <!-- DESKTOP -->
          <div class="panel-desktop-content" [ngbCollapse]="isGroupCollapsed">
            <div class="panel-body">
              <ul class="panel-list">
                <li
                  *ngFor="let lote of lotesGestionar; index as i"
                  class="panel-list-item"
                  (click)="onGrupoClick(lote)"
                  appLongPress
                  (longPress)="onDocumentoLongPress(lote)"
                >
                  <span
                    class="item-icon icon-purple"
                    [style]="
                      firmaUtils.getStyleFirma(
                        lote.firma_simple,
                        lote?.id_servicio_externo,
                        lote?.es_grupo,
                        lote.firma_por_plantilla
                      )
                    "
                  >
                    <i
                      class="{{
                        firmaUtils.getIconFirma(
                          lote.firma_simple,
                          lote?.id_servicio_externo,
                          lote?.es_grupo,
                          lote.firma_por_plantilla
                        )
                      }}"
                    ></i>
                  </span>

                  <span class="item-content">
                    <strong>
                      {{ lote?.titulo }}
                    </strong>

                    <small>
                      {{ formatFechaLocalSinUTC(lote?.createdAt) }} -
                      {{
                        firmaUtils.getTipoFirma(
                          lote.firma_simple,
                          lote?.id_servicio_externo,
                          lote?.es_grupo,
                          lote.firma_por_plantilla
                        )
                      }}
                    </small>
                  </span>

                  <span class="item-arrow">
                    <i class="fa-solid fa-chevron-right"></i>
                  </span>
                </li>
              </ul>
            </div>

            <div
              class="panel-footer"
              *ngIf="
                !isGroupCollapsed &&
                totalItemsLotesGestionar > lotesGestionar.length
              "
            >
              <span>
                Mostrando {{ lotesGestionar.length }} de
                {{ totalItemsLotesGestionar }}
              </span>

              <button
                type="button"
                class="panel-more"
                (click)="
                  rederic('firmas-pendientes-avances/firmas-pendientes-avances')
                "
              >
                Ver todos
                <i class="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>

          <!-- MÓVIL -->
          <div class="panel-mobile-content">
            <div class="panel-body">
              <ul class="panel-list">
                <li
                  *ngFor="let lote of lotesGestionar; index as i"
                  class="panel-list-item"
                  (click)="onGrupoClick(lote)"
                  appLongPress
                  (longPress)="onDocumentoLongPress(lote)"
                >
                  <span
                    class="item-icon icon-purple"
                    [style]="
                      firmaUtils.getStyleFirma(
                        lote.firma_simple,
                        lote?.id_servicio_externo,
                        lote?.es_grupo,
                        lote.firma_por_plantilla
                      )
                    "
                  >
                    <i
                      class="{{
                        firmaUtils.getIconFirma(
                          lote.firma_simple,
                          lote?.id_servicio_externo,
                          lote?.es_grupo,
                          lote.firma_por_plantilla
                        )
                      }}"
                    ></i>
                  </span>

                  <span class="item-content">
                    <strong>
                      {{ lote?.titulo }}
                    </strong>

                    <small>
                      {{ formatFechaLocalSinUTC(lote?.createdAt) }} -
                      {{
                        firmaUtils.getTipoFirma(
                          lote.firma_simple,
                          lote?.id_servicio_externo,
                          lote?.es_grupo,
                          lote.firma_por_plantilla
                        )
                      }}
                    </small>
                  </span>

                  <span class="item-arrow">
                    <i class="fa-solid fa-chevron-right"></i>
                  </span>
                </li>
              </ul>
            </div>

            <div
              class="panel-footer"
              *ngIf="totalItemsLotesGestionar > lotesGestionar.length"
            >
              <span>
                Mostrando {{ lotesGestionar.length }} de
                {{ totalItemsLotesGestionar }}
              </span>

              <button
                type="button"
                class="panel-more"
                (click)="
                  rederic('firmas-pendientes-avances/firmas-pendientes-avances')
                "
              >
                Ver todos
                <i class="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </article>

        <!-- ======================================================
             3. ÚLTIMOS LOTES COMPLETADOS
             ====================================================== -->
        <article data-tour="lotes-completados" class="dashboard-panel">
          <!-- DESKTOP -->
          <button
            type="button"
            class="panel-header panel-header-desktop"
            (click)="isLastDocsCollapsed = !isLastDocsCollapsed"
            [attr.aria-expanded]="!isLastDocsCollapsed"
          >
            <div class="panel-header-left">
              <!-- <span class="panel-main-icon icon-green">
                <i class="fa-solid fa-circle-check"></i>
              </span> -->

              <span class="panel-heading-text">
                <strong>Últimos sobres completados</strong>
                <small>Documentos finalizados recientemente</small>
              </span>
            </div>

            <div class="panel-header-right">
              <span class="panel-counter">
                {{ totalItemslotesFirmados }}
              </span>

              <span class="panel-collapse-icon">
                <i
                  class="fa-solid fa-chevron-down"
                  [class.rotate-180]="!isLastDocsCollapsed"
                >
                </i>
              </span>
            </div>
          </button>

          <!-- MÓVIL -->
          <div class="panel-header panel-header-mobile">
            <div class="panel-header-left">
              <!-- <span class="panel-main-icon icon-green">
                <i class="fa-solid fa-circle-check"></i>
              </span> -->

              <span class="panel-heading-text">
                <strong>Últimos sobres completados</strong>
                <small>Documentos finalizados recientemente</small>
              </span>
            </div>

            <span class="panel-counter">
              {{ totalItemslotesFirmados }}
            </span>
          </div>

          <!-- DESKTOP -->
          <div
            class="panel-desktop-content"
            [ngbCollapse]="isLastDocsCollapsed"
          >
            <div class="panel-body">
              <ul class="panel-list">
                <li
                  *ngFor="let lote of lotesFirmados; index as i"
                  class="panel-list-item"
                  (click)="onDocumentoClick(lote)"
                  appLongPress
                  (longPress)="onDocumentoLongPress(lote)"
                >
                  <span
                    class="item-icon icon-green"
                    [style]="
                      firmaUtils.getStyleFirma(
                        lote.firma_simple,
                        lote?.id_servicio_externo,
                        lote?.es_grupo,
                        lote.firma_por_plantilla
                      )
                    "
                  >
                    <i
                      class="{{
                        firmaUtils.getIconFirma(
                          lote.firma_simple,
                          lote?.id_servicio_externo,
                          lote?.es_grupo,
                          lote.firma_por_plantilla
                        )
                      }}"
                    ></i>
                  </span>

                  <span class="item-content">
                    <strong>
                      {{ lote?.titulo }}
                    </strong>

                    <small>
                      {{ formatFechaLocalSinUTC(lote?.createdAt) }} -
                      {{
                        firmaUtils.getTipoFirma(
                          lote.firma_simple,
                          lote?.id_servicio_externo,
                          lote?.es_grupo,
                          lote.firma_por_plantilla
                        )
                      }}
                    </small>
                  </span>

                  <span class="item-arrow">
                    <i class="fa-solid fa-chevron-right"></i>
                  </span>
                </li>
              </ul>
            </div>

            <div
              class="panel-footer"
              *ngIf="!isLastDocsCollapsed && lotesFirmados?.length"
            >
              <span>
                Mostrando {{ lotesFirmados.length }} de
                {{ totalItemslotesFirmados || lotesFirmados.length }}
              </span>

              <button
                type="button"
                class="panel-more"
                (click)="
                  rederic('ultimos-lotes-completados/ultimos-lotes-completados')
                "
              >
                Ver todos
                <i class="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>

          <!-- MÓVIL -->
          <div class="panel-mobile-content">
            <div class="panel-body">
              <ul class="panel-list">
                <li
                  *ngFor="let lote of lotesFirmados; index as i"
                  class="panel-list-item"
                  (click)="onDocumentoClick(lote)"
                  appLongPress
                  (longPress)="onDocumentoLongPress(lote)"
                >
                  <span
                    class="item-icon icon-green"
                    [style]="
                      firmaUtils.getStyleFirma(
                        lote.firma_simple,
                        lote?.id_servicio_externo,
                        lote?.es_grupo,
                        lote.firma_por_plantilla
                      )
                    "
                  >
                    <i
                      class="{{
                        firmaUtils.getIconFirma(
                          lote.firma_simple,
                          lote?.id_servicio_externo,
                          lote?.es_grupo,
                          lote.firma_por_plantilla
                        )
                      }}"
                    ></i>
                  </span>

                  <span class="item-content">
                    <strong>
                      {{ lote?.titulo }}
                    </strong>

                    <small>
                      {{ formatFechaLocalSinUTC(lote?.createdAt) }} -
                      {{
                        firmaUtils.getTipoFirma(
                          lote.firma_simple,
                          lote?.id_servicio_externo,
                          lote?.es_grupo,
                          lote.firma_por_plantilla
                        )
                      }}
                    </small>
                  </span>

                  <span class="item-arrow">
                    <i class="fa-solid fa-chevron-right"></i>
                  </span>
                </li>
              </ul>
            </div>

            <div class="panel-footer" *ngIf="lotesFirmados?.length">
              <span>
                Mostrando {{ lotesFirmados.length }} de
                {{ totalItemslotesFirmados || lotesFirmados.length }}
              </span>

              <button
                type="button"
                class="panel-more"
                (click)="
                  rederic('ultimos-lotes-completados/ultimos-lotes-completados')
                "
              >
                Ver todos
                <i class="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </article>
      </div>

      <!-- ========================================================
           4. REINTENTOS
           Desktop: dentro del 2x2
           Mobile: FUERA DEL CARRUSEL
           ======================================================== -->
      <div class="retry-container">
        <div class="retry-label">
          <span>Requiere atención</span>
        </div>

        <article
          data-tour="pendientes-reintentos-firmas"
          class="dashboard-panel retry-panel"
        >
          <button
            type="button"
            class="panel-header retry-header"
            (click)="isDocsWithRetries = !isDocsWithRetries"
            [attr.aria-expanded]="!isDocsWithRetries"
          >
            <div class="panel-header-left">
              <!-- <span class="panel-main-icon icon-red">
                <i class="fa-solid fa-triangle-exclamation"></i>
              </span> -->

              <span class="panel-heading-text">
                <strong>Firmas pendientes de reintento</strong>
                <small>Firmas que requieren atención</small>
              </span>
            </div>

            <div class="panel-header-right">
              <span
                id="reintento"
                class="reload-button"
                role="button"
                tabindex="0"
                title="Recargar"
                (click)="onReload(); $event.stopPropagation()"
              >
                <i class="fa-solid fa-rotate"></i>
              </span>

              <span class="panel-counter counter-red">
                {{ totalItemsReintentos }}
              </span>

              <span class="panel-collapse-icon">
                <i
                  class="fa-solid fa-chevron-down"
                  [class.rotate-180]="!isDocsWithRetries"
                >
                </i>
              </span>
            </div>
          </button>

          <div [ngbCollapse]="isDocsWithRetries">
            <div class="panel-body">
              <ng-container *ngIf="totalItemsReintentos > 0; else emptyState">
                <ul class="panel-list">
                  <li
                    *ngFor="let lote of lotesReintentos; index as i"
                    class="panel-list-item retry-item"
                    appLongPress
                    (longPress)="onDocumentoLongPress(lote)"
                    (click)="openModalReintentos(modalLoteReintento, lote)"
                  >
                    <span
                      class="item-icon icon-red"
                      [style]="
                        firmaUtils.getStyleFirma(
                          lote.firma_simple,
                          lote?.id_servicio_externo,
                          lote?.es_grupo,
                          lote.firma_por_plantilla
                        )
                      "
                    >
                      <i
                        class="{{
                          firmaUtils.getIconFirma(
                            lote.firma_simple,
                            lote?.id_servicio_externo,
                            lote?.es_grupo,
                            lote.firma_por_plantilla
                          )
                        }}"
                      ></i>
                    </span>

                    <span class="item-content">
                      <strong>
                        {{ lote?.titulo }}
                      </strong>

                      <small>
                        {{ formatFechaLocalSinUTC(lote?.created_at) }} -
                        {{
                          firmaUtils.getTipoFirma(
                            lote.firma_simple,
                            lote?.id_servicio_externo,
                            lote?.es_grupo,
                            lote.firma_por_plantilla
                          )
                        }}
                      </small>
                    </span>

                    <span class="item-arrow item-arrow-red">
                      <i class="fa-solid fa-chevron-right"></i>
                    </span>
                  </li>
                </ul>
              </ng-container>

              <ng-template #emptyState>
                <div class="panel-empty">
                  <span class="empty-icon">
                    <i class="fa-solid fa-circle-check"></i>
                  </span>

                  <span>
                    <strong>Todo al día</strong>
                    <small>No hay firmas pendientes de reintento.</small>
                  </span>
                </div>
              </ng-template>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</div>

<!-- ================================================================
     MODAL RESUMEN DE FIRMA
     ORIGINAL - CONSERVADO
     ================================================================ -->

<ng-template #modalGruposResumenes let-modal>
  <div
    class="modal-header dashboard-modal-header modal-resume-header border-0 pb-0"
  >
    <div>
      <h4 class="modal-title mb-0" style="text-transform: none !important">
        Resumen de firma
      </h4>

      <small class="text-muted"> Avance de firmas </small>
    </div>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body pt-2">
    <h5 class="text-center">
      {{ loteSelected.titulo }}
    </h5>

    <div
      class="resume-modal mt-4"
      *ngFor="let resumen of resumenAvanceFirma; index as i"
    >
      <div class="resume-header">
        <div class="resume-group-name">
          {{ resumen.nombre }}
        </div>

        <span class="resume-tag" *ngIf="resumen.es_grupo"> Firma grupal </span>

        <span class="resume-tag" *ngIf="!resumen.es_grupo">
          Firma individual
        </span>
      </div>

      <div class="resume-stats">
        <div class="resume-stat">
          <span class="resume-stat-label"> Solicitadas </span>

          <span class="resume-stat-value">
            {{ resumen.cantidad_total }}
          </span>
        </div>

        <div class="resume-stat">
          <span class="resume-stat-label"> Completadas </span>

          <span class="resume-stat-value text-success">
            {{ resumen.cantidad_firmada }}
          </span>
        </div>

        <div class="resume-stat">
          <span class="resume-stat-label"> Pendientes </span>

          <span class="resume-stat-value text-warning">
            {{ resumen.cantidad_total - resumen.cantidad_firmada }}
          </span>
        </div>
      </div>

      <div class="resume-progress">
        <div
          class="d-flex justify-content-between align-items-center mb-1 small"
        >
          <span class="text-muted"> Progreso general </span>

          <span class="fw-semibold">
            {{ resumen.cantidad_firmada }}
            /
            {{ resumen.cantidad_total }}
          </span>
        </div>

        <div class="progress" style="height: 8px">
          <div
            class="progress-bar bg-success"
            role="progressbar"
            [style.width.%]="getProgress(resumen)"
            [attr.aria-valuenow]="getProgress(resumen)"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
    </div>

    <br />
  </div>

  <div class="modal-footer border-0 pt-2">
    <button
      type="button"
      class="btn btn-primary w-100 mt-3"
      (click)="rederic('firmas/firmantes/' + loteSelected.id)"
      *ngIf="loteSelected.es_grupo"
    >
      <i class="fa fa-eye me-1"></i>
      Ver detalle
    </button>

    <button
      type="button"
      class="btn btn-outline-secondary w-100"
      (click)="modal.close('Cerrar click')"
    >
      Cerrar
    </button>
  </div>
</ng-template>

<!-- ================================================================
     MODAL DESCARGAR DOCUMENTO
     ORIGINAL - CONSERVADO
     ================================================================ -->

<ng-template #modalDescargaDocumento let-modal>
  <div
    class="modal-header dashboard-modal-header modal-download-header border-0 pb-0"
  >
    <div>
      <h4 class="modal-title mb-0">Descargar documento</h4>

      <small class="text-muted"> Previsualiza y descarga tu archivo: </small>

      <div class="download-filename">
        {{ loteSelected.titulo }}
      </div>
    </div>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body pt-2">
    <div class="download-modal">
      <div class="download-icon text-center">
        <i class="fa fa-download" style="font-size: 4em"> </i>
      </div>

      <button
        type="button"
        class="btn btn-primary w-100 mt-3"
        (click)="descargarZipPorLote()"
      >
        <i class="fa fa-arrow-down me-1"></i>
        Descargar
      </button>
    </div>
  </div>

  <div class="modal-footer border-0 pt-2">
    <button
      type="button"
      class="btn btn-outline-secondary w-100"
      (click)="modal.close('Cerrar click')"
    >
      Cerrar
    </button>
  </div>
</ng-template>

<!-- ================================================================
     MODAL REINTENTOS
     ORIGINAL - CONSERVADO
     ================================================================ -->

<ng-template #modalLoteReintento let-modal>
  <div
    class="modal-header dashboard-modal-header modal-retry-header border-0 pb-0"
  >
    <div>
      <h4 class="modal-title mb-0" style="text-transform: none !important">
        Sobres con reintentos
      </h4>

      <small class="text-muted" style="font-size: 1.4em">
        {{ loteSelected?.titulo }}
      </small>
    </div>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body pt-2">
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <caption class="visually-hidden">
          Reintentos
        </caption>

        <thead>
          <tr>
            <td>Firmante</td>
            <td>Scratchcard</td>
            <td>Reintentar</td>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let detalle of lotesReintentosDetalles; index as i">
            <td>
              {{ detalle.usuario_nombre }}
            </td>

            <td>
              {{ detalle.scratchcard }}
            </td>

            <td>
              <button class="btn btn-success" (click)="crearReintento(detalle)">
                <i class="fa fa-refresh" aria-hidden="true"> </i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer border-0 pt-2">
    <button
      type="button"
      class="btn btn-outline-secondary w-100"
      (click)="modal.close('Cerrar click')"
    >
      Cerrar
    </button>
  </div>
</ng-template>
